(function () {
  function showCopied(statusEl) {
    if (!statusEl) return;
    statusEl.hidden = false;
    statusEl.textContent = 'Link gekopieerd';
    window.setTimeout(function () {
      statusEl.hidden = true;
    }, 3000);
  }

  function copyUrl(url, statusEl) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        showCopied(statusEl);
      }).catch(function () {
        window.prompt('Kopieer deze link:', url);
      });
      return;
    }
    window.prompt('Kopieer deze link:', url);
  }

  function initShareButtons() {
    var buttons = document.querySelectorAll('[data-mpg-share]');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var url = window.location.href;
        var title = document.title || '';
        var descEl = document.querySelector('meta[name="description"]');
        var text = descEl && descEl.content ? descEl.content : '';
        var statusEl = btn.closest('.mpg-pdf') && btn.closest('.mpg-pdf').querySelector('[data-mpg-share-status]');

        if (navigator.share) {
          navigator.share({ title: title, text: text, url: url }).catch(function () {
            copyUrl(url, statusEl);
          });
          return;
        }

        copyUrl(url, statusEl);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShareButtons);
  } else {
    initShareButtons();
  }
})();
